import * as React from "react";
import { LinkProps } from "../types";
import styles from "./index.module.css";

function Anchor(props: LinkProps) {
  function className() {
    return (
      styles.a +
      (props.variant ? ` ${styles[props.variant]}` : "") +
      (props.cssClass ? ` ${props.cssClass}` : "")
    );
  }

  return (
    <a target="_blank" href={props.href} className={className()}>
      {props.linkText}
    </a>
  );
}

export default Anchor;
